import Rating from '@material-ui/lab/Rating';
import { styled } from '@material-ui/core/styles';

// ================== These are custom Ratings components =======================

// TYPE 1
const CustomRatings = styled(Rating)({
    '& .MuiRating-iconFilled': {
        color: '#3F8BBF',
    },
    '& .MuiRating-iconHover': {
        color: '#92B9D5',
    },
});

// TYPE 2
const CustomRatings1 = styled(Rating)({
    '& .MuiRating-iconFilled': {
        color: '#92B9D5',
    },
    '& .MuiRating-iconHover': {
        color: '#3F8BBF',
    },
});

// TYPE 3
const CustomRatings2 = styled(Rating)({
    '& .MuiRating-iconFilled': {
        color: '#1A4D6D',
    },
    '& .MuiRating-iconHover': {
        color: '#1a4d6d',
    },
});


export { CustomRatings,CustomRatings1,CustomRatings2 };
